import { CourseType } from "@core/schema/CourseType.js";
import comingSoonImage from "./assets/images/coming-soon.png?webp&w=900&imagetools";
import homeEspressoGallery1 from "./assets/images/home-espresso-gallery-1.webp?webp&w=900&imagetools";
import homeEspressoGallery2 from "./assets/images/home-espresso-gallery-2.webp?webp&w=900&imagetools";
import homeEspressoGallery3 from "./assets/images/home-espresso-gallery-3.webp?webp&w=900&imagetools";
import homeEspressoImage from "./assets/images/home-espresso-hero.webp?webp&w=900&imagetools";
import homeFilterCoffeeGallery1 from "./assets/images/home-filter-coffee-gallery-1.webp?webp&w=900&imagetools";
import homeFilterCoffeeGallery2 from "./assets/images/home-filter-coffee-gallery-2.webp?webp&w=900&imagetools";
import homeFilterCoffeeGallery3 from "./assets/images/home-filter-coffee-gallery-3.webp?webp&w=900&imagetools";
import homeFilterCoffeeImage from "./assets/images/home-filter-coffee-hero.webp?webp&w=900&imagetools";
import scaFoundationGallery1 from "./assets/images/sca-foundation-gallery-1.jpg?webp&w=900&imagetools";
import scaFoundationGallery2 from "./assets/images/sca-foundation-gallery-2.jpg?webp&w=900&imagetools";
import scaFoundationGallery3 from "./assets/images/sca-foundation-gallery-3.jpg?webp&w=900&imagetools";
import scaFoundationImage from "./assets/images/sca-foundation-hero.jpg?webp&w=900&imagetools";
import scaIntermediateGallery1 from "./assets/images/sca-intermediate-gallery-1.jpg?webp&w=900&imagetools";
import scaIntermediateGallery2 from "./assets/images/sca-intermediate-gallery-2.jpg?webp&w=900&imagetools";
import scaIntermediateGallery3 from "./assets/images/sca-intermediate-gallery-3.jpg?webp&w=900&imagetools";
import scaIntermediateImage from "./assets/images/sca-intermediate-hero.jpg?webp&w=900&imagetools";

export const courseTypeGalleryMap: Partial<Record<CourseType, string[]>> = {
	[CourseType.HomeFilterCoffee]: [
		homeFilterCoffeeImage,
		homeFilterCoffeeGallery1,
		homeFilterCoffeeGallery2,
		homeFilterCoffeeGallery3,
	],
	[CourseType.HomeEspresso]: [homeEspressoImage, homeEspressoGallery1, homeEspressoGallery2, homeEspressoGallery3],
	[CourseType.SCAFoundation]: [scaFoundationImage, scaFoundationGallery1, scaFoundationGallery2, scaFoundationGallery3],
	[CourseType.SCAIntermediate]: [
		scaIntermediateImage,
		scaIntermediateGallery1,
		scaIntermediateGallery2,
		scaIntermediateGallery3,
	],
};

export function getCourseTypeGallery(courseType: CourseType): string[] {
	return courseTypeGalleryMap[courseType] ?? [comingSoonImage];
}
